import { render, staticRenderFns } from "./GFMigratedFundForm.vue?vue&type=template&id=582b2602"
import script from "./GFMigratedFundForm.vue?vue&type=script&lang=js"
export * from "./GFMigratedFundForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports